export default {
  data () {
    return {
    }
  },
  computed: {
    // 判断是为苹果手机登录
    isIosStatus () {
      return this.$tkUa.isPlus && this.$tkUa.isIos
    },
  },
  mounted () {
    this.setStatusBar('dark')
  },
  methods: {
    // 获取符合条件的单条数据
    async onlyId (className, obj) {
      let res = await this.$tkParse.get(`/classes/${className}`, {
        params: {
          limit: 1,
          where: obj
        }
      })
      return res.results ? res.results[0] : null
    },
    // 统计相关数量接口调用方法
    async statisticsNum (className, obj) {
      let countData = await this.$tkParse.get(`/classes/${className}`, {
        params: {
          count: 1,
          limit: 0,
          where: obj
        }
      })
      if (countData.data.count) { return countData.data.count } else { return 0 }
    },
    // 统计数据总数量
    async getGroupTotal (className, obj) {
      let res = await this.$tkParse.get(`/aggregate/${className}`, {
        params: {
          group: {
            objectId: '',
            total: { $sum: 1 }
          },
          where: obj,
          match: obj
        }
      })
      return res.results[0].total
    },
    // 设置状态栏文字颜色
    setStatusBar (color) {
      if (window.plus) { window.plus.navigator.setStatusBarStyle(color) }
    }
  }
}
